"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioTable = exports.radioGroup = exports.textWithHeaderBar = exports.headerBar = exports.weatherBlock = exports.commentBlock = exports.basicTable = exports.markupBlock = exports.signatureBlockVerification = exports.signatureBlock = exports.imageBlock = exports.groupNameHeader = exports.header = void 0;
/* eslint-disable max-len */
/**
 * Company Header for non-bundle forms - has company info like name, address, as well as schema and form id info
 * <img src="partial_examples/header.png">
 * @name header
 * @example {{>header}}
 */
var header_hbs_1 = require("./hbs-partials/header.hbs");
Object.defineProperty(exports, "header", { enumerable: true, get: function () { return __importDefault(header_hbs_1).default; } });
/**
 * Group Name Header for non-bundle forms - same as header, but uses project group name instead of company name
 * <img src="partial_examples/groupNameHeader.png">
 * @name groupNameHeader
 * @example {{>groupNameHeader}}
 */
exports.groupNameHeader = "{{>header isGroupHeader=true}}";
/**
 * Displays images and other attachments based on file type
 * <img src="partial_examples/imageBlock.png">
 * @name imageBlock
 * @param { Array<Record<string, string>> } imageArray Array holding the attachments
 * @example {{>imageBlock imageArray=subcontractor_use.images}}
 */
var image_block_hbs_1 = require("./hbs-partials/image_block.hbs");
Object.defineProperty(exports, "imageBlock", { enumerable: true, get: function () { return __importDefault(image_block_hbs_1).default; } });
/**
 * Only the signature display, no verification boxes
 * <img src="partial_examples/signatureBlock.png">
 * @name signatureBlock
 * @param { Record<string, any> } signatureInfo Required. the signature object with signature, name, and date
 * @param { string } sectionTitle Optional. Text to show in the gray section header. Default value is "Signature"
 * @param { boolean } forceDisplayBlock Optional. Set to true to force display the signature block. Default is false.
 * @example {{>signatureBlock
 *      signatureInfo=subcontractor_use.subcontractor_signature
 *      sectionTitle="Subcontractor's Signature"
 *      forceDisplayBlock=true
 * }}
 */
var signature_block_basic_hbs_1 = require("./hbs-partials/signature_block_basic.hbs");
Object.defineProperty(exports, "signatureBlock", { enumerable: true, get: function () { return __importDefault(signature_block_basic_hbs_1).default; } });
/**
 * Signature block with the verification checkmarks - common for GC and Owner Verification
 * <img src="partial_examples/signatureBlockVerification.png">
 * @name signatureBlockVerification
 * @param { Record<string, any> } verificationInfo Required. Root signature object that contains the verify booleans
 * @param { Record<string, any> } signatureInfo Required. The nested signature object with signature, name, and date
 * @param { string } sectionTitle Optional. Text to show in the gray section header. Default value is "Signature"
 * @param { boolean } forceDisplayBlock Optional. Set to true to force display the signature block. Default is false.
 * @example {{>signatureBlockVerification
 *      verificationInfo=gc_field_verification
 *      signatureInfo=gc_field_verification.general_contractors_signature
 *      sectionTitle="General Contractor Verification"
 *      forceDisplayBlock=true
 * }}

 */
var signature_block_w_verification_hbs_1 = require("./hbs-partials/signature_block_w_verification.hbs");
Object.defineProperty(exports, "signatureBlockVerification", { enumerable: true, get: function () { return __importDefault(signature_block_w_verification_hbs_1).default; } });
/**
 * Markups and total cost section for Labor, Equipment, and Materials Markups
 * <img src="partial_examples/markupBlock.png">
 * @name markupBlock
 * @param { string } sectionTitle For the total header at the bottom - plugged into "Total {{sectionTitle}} Cost"
 * @param { Record<string, any> } markupsSection The markups object
 * @param { Number } sectionTotal Use a helper to calculate the section total + the list wrapped in ()
 * @example {{>markupBlock
 *      sectionTitle="Equipment"
 *      markupsSection=subcontractor_use.equipment_markup
 *      sectionTotal=(getEquipmentPricingTotal subcontractor_use.equipment)
 * }}
 */
var markup_block_hbs_1 = require("./hbs-partials/markup_block.hbs");
Object.defineProperty(exports, "markupBlock", { enumerable: true, get: function () { return __importDefault(markup_block_hbs_1).default; } });
/**
 * For a basic table where no calculations need to be done and it is just headers and values from the store.
 * Use the makeArray helper to create a list of headers and infoKeys to display.<br>
 * Header/infoKeys should be in the order you want them presented.<br>
 * If a cell combines multiple infoKeys in a single cell (ex. last_name, first_name) you can nest multiple `makeArray` calles
 * like <br> `infoKeys=(makeArray (makeArray "employee.last_name" "employee.first_name") "employee.classification")`<br>
 * This would result in two cells, the first with last/first name info, and second with classification
 * Currenty this only works with values that do not need special formatting. Cannot support dates or currency.
 * <img src="partial_examples/basicTable.png">
 * @name basicTable
 * @param { Array<Record<string, any>> } listToDisplay The base list with values to be displayed in the table
 * @param { string } sectionTitle Name to display in the bar above the table
 * @param { Array<string> } infoKeys List of the field keys on the list items to display
 * @param { Array<string> } headers List of the header titles to display
 * @param { string } iconName Optional Icon to use for the list.
 * @param { Array<string> } columnAlignment Optional. List of "L" or "R" to set column text alignment. If none given, all will be left aligned.
 * @param { string } headerStyles Optional. Any additional styles that should be added to legend styles.
 * @example {{>basicTable
 *      listToDisplay=subcontractor_use.lower_tier_sub
 *      sectionTitle="Lower Tier Sub"
 *      infoKeys=(makeArray "company_name" "total_labor" "total_hours" "equipment" "material" "note")
 *      headers=(makeArray "Company Name" "Total Labor" "Total Hours" "Equipment" "Material" "Note")
 *      iconName="material"
 *      columnAlignment=(makeArray "L" "R" "R" "R" "R" "L")
 *      headerStyles="margin-top: 10px;"
 * }}
 */
var basic_table_hbs_1 = require("./hbs-partials/basic_table.hbs");
Object.defineProperty(exports, "basicTable", { enumerable: true, get: function () { return __importDefault(basic_table_hbs_1).default; } });
/**
 * Block for displaying Comments with comment, commenter, and date
 * <img src="partial_examples/commentBlock.png">
 * @name commentBlock
 * @param { Record<string, any> } commentSection Object holding information about the signature
 * @param { string } sectionTitle Optional. Defaults to "Comments"
 * @param { boolean } inTable Optional. If nesting the comment in a table, set this to true. Default is false.
 * @example {{>commentBlock
 *     commentSection=subcontractor_use.comment
 *     sectionTitle="Sub Comments"
 *     inTable=true
 * }}
 */
var comment_block_hbs_1 = require("./hbs-partials/comment_block.hbs");
Object.defineProperty(exports, "commentBlock", { enumerable: true, get: function () { return __importDefault(comment_block_hbs_1).default; } });
/**
 * Local Weather Block with morning, afternoon, and evening weather information
 * <img src="partial_examples/weatherBlock.png">
 * @name weatherBlock
 * @param { Record<string, string> } weatherSection Section containing the local weather information
 * @param { string } weatherNote Optional If there is a field with a note for weather it will be displayed
 * @example {{>weatherBlock
 *     weatherSection=daily_report.weather
 *     weatherNote=daily_report.weather_note
 * }}
 */
var weather_hbs_1 = require("./hbs-partials/weather.hbs");
Object.defineProperty(exports, "weatherBlock", { enumerable: true, get: function () { return __importDefault(weather_hbs_1).default; } });
/**
 * Dark gray bar used as a header
 * <img src="partial_examples/headerBar.png">
 * @name headerBar
 * @param { string } sectionTitle Name to display in the bar above the table
 * @param { string } iconName Optional. Icon to use for the list.
 * @param { number } itemCount Optional. If using for list, this will display item count. Use length helper to get count.
 * @example {{>headerBar
 *      sectionTitle="Labor"
 *      iconName="labor"
 *      itemCount=(length subcontractor_use.labor)
 * }}
 */
var header_bar_hbs_1 = require("./hbs-partials/header_bar.hbs");
Object.defineProperty(exports, "headerBar", { enumerable: true, get: function () { return __importDefault(header_bar_hbs_1).default; } });
/**
 * Text area below a dark gray legend/header bar - displays legend and single text entry in bolded font.
 * <img src="partial_examples/textWithHeaderBar.png">
 * @name textWithHeaderBar
 * @param { string } sectionTitle Name to display in the bar above the table
 * @param { string } valueToDisplay Text value to display in the textbox.
 * @param { string } iconName Optional. Icon to use in the header.
 * @example {{>textWithHeaderBar
 *      sectionTitle="Additional Actions"
 *      valueToDisplay=field_report.additional_actions
 *      iconName="safety"
 * }}
 */
var text_w_header_bar_hbs_1 = require("./hbs-partials/text_w_header_bar.hbs");
Object.defineProperty(exports, "textWithHeaderBar", { enumerable: true, get: function () { return __importDefault(text_w_header_bar_hbs_1).default; } });
/**
 * A group of radio buttons with the field label and options pulled from the schema
 * <img src="partial_examples/radioGroup.png">
 * @name radioGroup
 * @param { string } valueToDisplay Text value to display in the textbox.
 * @param { string[] } pathToValue Path to value tht we will use to pull enum options from schema
 * @example {{>radioGroup
 *      valueToDisplay=field_report.additional_actions
 *      pathToValue="field_report.additional_actions"
 * }}
 */
var radio_group_hbs_1 = require("./hbs-partials/radio_group.hbs");
Object.defineProperty(exports, "radioGroup", { enumerable: true, get: function () { return __importDefault(radio_group_hbs_1).default; } });
/**
 * A group of radio buttons with the field label and options pulled from the schema
 * <img src="partial_examples/radioTable.png">
 * @name radioTable
 * @param { string } valueToDisplay Text value to display in the textbox.
 * @param { string[] } pathToValue Path to value tht we will use to pull enum options from schema
 * @example {{>radioTable
 *      valueToDisplay=field_report.additional_actions
 *      pathToValue="field_report.additional_actions"
 * }}
 */
var radio_table_hbs_1 = require("./hbs-partials/radio_table.hbs");
Object.defineProperty(exports, "radioTable", { enumerable: true, get: function () { return __importDefault(radio_table_hbs_1).default; } });
